import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { budgetApi } from '../api';

const KATEGORIEN = [
  { name: 'Vertragskosten', icon: '📋', farbe: '#6366f1' },
  { name: 'Zahlungen & Kredite', icon: '🏦', farbe: '#ef4444' },
  { name: 'Sparverträge', icon: '💰', farbe: '#10b981' },
  { name: 'Ausgaben & Inventar', icon: '🧾', farbe: '#f59e0b' },
  { name: 'Lebensmittel', icon: '🛒', farbe: '#06b6d4' },
  { name: 'Freizeit', icon: '🎮', farbe: '#8b5cf6' },
  { name: 'Mobilität', icon: '🚗', farbe: '#f97316' },
  { name: 'Wohnen', icon: '🏠', farbe: '#84cc16' },
  { name: 'Gesundheit', icon: '🏥', farbe: '#ec4899' },
  { name: 'Sonstiges', icon: '📦', farbe: '#64748b' },
];

export default function BudgetPage() {
  const navigate = useNavigate();
  const [auswertung, setAuswertung] = useState(null);
  const [budgets, setBudgets] = useState([]);
  const [laden, setLaden] = useState(true);
  const [ansicht, setAnsicht] = useState('monatlich');
  const [zeigeFormular, setZeigeFormular] = useState(false);
  const [bearbeiteId, setBearbeiteId] = useState(null);
  const [form, setForm] = useState({ name: '', kategorie: 'Vertragskosten', betrag_monatlich: '', farbe: '#6366f1', icon: '💰', notizen: '' });
  const [fehler, setFehler] = useState('');

  useEffect(() => { datenLaden(); }, []);

  async function datenLaden() {
    setLaden(true);
    try {
      const [a, b] = await Promise.all([budgetApi.auswertung(), budgetApi.list()]);
      setAuswertung(a.data);
      setBudgets(b.data);
    } catch(e) { console.error(e); }
    setLaden(false);
  }

  function kategorieWaehlen(name) {
    const kat = KATEGORIEN.find(k => k.name === name);
    setForm(f => ({ ...f, kategorie: name, farbe: kat?.farbe || '#6366f1', icon: kat?.icon || '💰' }));
  }

  async function speichern(e) {
    e.preventDefault(); setFehler('');
    try {
      if (bearbeiteId) await budgetApi.update(bearbeiteId, form);
      else await budgetApi.create(form);
      setZeigeFormular(false); setBearbeiteId(null);
      setForm({ name: '', kategorie: 'Vertragskosten', betrag_monatlich: '', farbe: '#6366f1', icon: '💰', notizen: '' });
      datenLaden();
    } catch(e) { setFehler(e.response?.data?.error || 'Fehler'); }
  }

  async function loeschen(id) {
    if (!window.confirm('Budget löschen?')) return;
    await budgetApi.delete(id);
    datenLaden();
  }

  function bearbeiten(b) {
    setForm({ name: b.name, kategorie: b.kategorie, betrag_monatlich: b.betrag_monatlich, farbe: b.farbe, icon: b.icon, notizen: b.notizen || '' });
    setBearbeiteId(b.id);
    setZeigeFormular(true);
  }

  const inp = { width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '14px', boxSizing: 'border-box' };
  const lbl = { display: 'block', marginBottom: '6px', fontWeight: '600', color: '#374151', fontSize: '13px' };

  const statusFarbe = (s) => s === 'gut' ? '#10b981' : s === 'warnung' ? '#f59e0b' : '#ef4444';
  const statusText = (s) => s === 'gut' ? '✅ Im Rahmen' : s === 'warnung' ? '⚠️ Achtung' : '🔴 Überschritten';

  const mult = ansicht === 'jaehrlich' ? 12 : 1;
  const label = ansicht === 'jaehrlich' ? 'jährlich' : 'monatlich';

  return (
    <div style={{ padding: '24px', maxWidth: '900px', margin: '0 auto' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', gap: '12px' }}>
        <h1 style={{ margin: 0, fontSize: '28px' }}>📊 Budgetplaner</h1>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
          <div style={{ display: 'flex', background: '#f1f5f9', borderRadius: '8px', padding: '4px' }}>
            {['monatlich', 'jaehrlich'].map(a => (
              <button key={a} onClick={() => setAnsicht(a)}
                style={{ padding: '6px 14px', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px',
                  background: ansicht === a ? '#6366f1' : 'transparent', color: ansicht === a ? 'white' : '#64748b', fontWeight: ansicht === a ? '600' : '400' }}>
                {a === 'monatlich' ? '📅 Monatlich' : '📆 Jährlich'}
              </button>
            ))}
          </div>
          <button onClick={() => { setZeigeFormular(true); setBearbeiteId(null); setForm({ name: '', kategorie: 'Vertragskosten', betrag_monatlich: '', farbe: '#6366f1', icon: '💰', notizen: '' }); }}
            style={{ padding: '10px 20px', background: '#6366f1', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}>
            + Budget
          </button>
        </div>
      </div>

      {/* Gesamt-KPIs */}
      {auswertung && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '16px', marginBottom: '24px' }}>
          {[
            { label: `Gesamt-Budget ${label}`, wert: (auswertung.gesamtSoll * mult), farbe: '#6366f1', icon: '🎯' },
            { label: `Ist-Ausgaben ${label}`, wert: (auswertung.gesamtIst * mult), farbe: auswertung.gesamtIst > auswertung.gesamtSoll ? '#ef4444' : '#10b981', icon: '📊' },
            { label: `Differenz ${label}`, wert: (auswertung.differenz * mult), farbe: auswertung.differenz >= 0 ? '#10b981' : '#ef4444', icon: '⚖️' },
          ].map((k, i) => (
            <div key={i} style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', borderLeft: `4px solid ${k.farbe}` }}>
              <div style={{ fontSize: '22px', marginBottom: '8px' }}>{k.icon}</div>
              <div style={{ fontSize: '20px', fontWeight: '700', color: k.farbe }}>
                {k.wert.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}
              </div>
              <div style={{ color: '#64748b', fontSize: '12px', marginTop: '4px' }}>{k.label}</div>
            </div>
          ))}
        </div>
      )}

      {/* Budget-Karten */}
      {laden ? <div style={{ textAlign: 'center', padding: '40px', color: '#94a3b8' }}>Lade...</div>
        : auswertung?.ergebnisse?.length === 0 && budgets.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>🎯</div>
            <div style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>Noch kein Budget definiert</div>
            <div style={{ marginBottom: '20px' }}>Lege dein erstes Budget an um deine Ausgaben zu überwachen</div>
            <button onClick={() => setZeigeFormular(true)}
              style={{ padding: '12px 24px', background: '#6366f1', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}>
              Erstes Budget anlegen
            </button>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {(auswertung?.ergebnisse || []).map(b => (
              <div key={b.id} style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ fontSize: '28px' }}>{b.icon}</div>
                    <div>
                      <div style={{ fontWeight: '700', fontSize: '16px' }}>{b.name}</div>
                      <div style={{ color: '#64748b', fontSize: '13px' }}>{b.kategorie}</div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <span style={{ background: statusFarbe(b.status) + '20', color: statusFarbe(b.status), padding: '4px 10px', borderRadius: '99px', fontSize: '12px', fontWeight: '600' }}>
                      {statusText(b.status)}
                    </span>
                    <button onClick={() => bearbeiten(b)} style={{ padding: '4px 10px', background: '#f1f5f9', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>✏️</button>
                    <button onClick={() => loeschen(b.id)} style={{ padding: '4px 10px', background: '#fee2e2', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>🗑️</button>
                  </div>
                </div>

                {/* Fortschrittsbalken */}
                <div style={{ marginBottom: '12px' }}>
                  <div style={{ background: '#f1f5f9', borderRadius: '99px', height: '10px', overflow: 'hidden' }}>
                    <div style={{ background: statusFarbe(b.status), width: `${Math.min(b.prozent, 100)}%`, height: '100%', borderRadius: '99px', transition: 'width 0.5s' }} />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px', fontSize: '12px', color: '#64748b' }}>
                    <span>{b.prozent}% genutzt</span>
                    <span style={{ fontWeight: '600', color: statusFarbe(b.status) }}>{b.differenz >= 0 ? `${(b.differenz * mult).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })} frei` : `${Math.abs(b.differenz * mult).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })} überschritten`}</span>
                  </div>
                </div>

                {/* Ist vs Soll */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: '12px' }}>
                  <div style={{ background: '#f8fafc', borderRadius: '8px', padding: '10px 14px' }}>
                    <div style={{ color: '#64748b', fontSize: '11px' }}>IST {label}</div>
                    <div style={{ fontWeight: '700', fontSize: '16px', color: statusFarbe(b.status) }}>{(b.ist_monatlich * mult).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</div>
                  </div>
                  <div style={{ background: '#f8fafc', borderRadius: '8px', padding: '10px 14px' }}>
                    <div style={{ color: '#64748b', fontSize: '11px' }}>SOLL {label}</div>
                    <div style={{ fontWeight: '700', fontSize: '16px', color: '#6366f1' }}>{(b.soll_monatlich * mult).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

      {/* Formular Modal */}
      {zeigeFormular && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: '20px' }}>
          <div style={{ background: 'white', borderRadius: '16px', padding: '24px', width: '100%', maxWidth: '500px', maxHeight: '90vh', overflowY: 'auto' }}>
            <h2 style={{ margin: '0 0 20px', fontSize: '20px' }}>{bearbeiteId ? '✏️ Budget bearbeiten' : '➕ Neues Budget'}</h2>
            {fehler && <div style={{ background: '#fee2e2', color: '#dc2626', padding: '12px', borderRadius: '8px', marginBottom: '16px' }}>{fehler}</div>}
            <form onSubmit={speichern} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label style={lbl}>Name *</label>
                <input style={inp} value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="z.B. Monatliches Gesamtbudget" required />
              </div>
              <div>
                <label style={lbl}>Kategorie *</label>
                <select style={inp} value={form.kategorie} onChange={e => kategorieWaehlen(e.target.value)}>
                  {KATEGORIEN.map(k => <option key={k.name} value={k.name}>{k.icon} {k.name}</option>)}
                </select>
              </div>
              <div>
                <label style={lbl}>Budget monatlich (€) *</label>
                <input style={inp} type="number" step="0.01" min="0" value={form.betrag_monatlich} onChange={e => setForm({...form, betrag_monatlich: e.target.value})} placeholder="0.00" required />
                {form.betrag_monatlich && <div style={{ fontSize: '12px', color: '#64748b', marginTop: '4px' }}>= {(parseFloat(form.betrag_monatlich) * 12).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })} / Jahr</div>}
              </div>
              <div>
                <label style={lbl}>Notizen</label>
                <textarea style={{ ...inp, minHeight: '60px', resize: 'vertical' }} value={form.notizen} onChange={e => setForm({...form, notizen: e.target.value})} placeholder="Optional..." />
              </div>
              <div style={{ display: 'flex', gap: '12px' }}>
                <button type="button" onClick={() => { setZeigeFormular(false); setBearbeiteId(null); }}
                  style={{ flex: 1, padding: '12px', background: '#f1f5f9', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}>Abbrechen</button>
                <button type="submit"
                  style={{ flex: 2, padding: '12px', background: '#6366f1', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}>
                  {bearbeiteId ? '💾 Speichern' : '➕ Budget anlegen'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
